// extracted by mini-css-extract-plugin
export default {"label":"ParserVersion_label__y61tD","description":"ParserVersion_description__VG-E5"};